import React from 'react';
import PropTypes from 'prop-types';

export default class SalesRep extends React.Component {
    static get props() {
        return {
            salesRepName: PropTypes.string,
            salesRepEmail: PropTypes.string,
            salesRepTerr: PropTypes.string,
            salesRepArea: PropTypes.string,
        };
    }

    render() {
        const {options} = this.props;
        return (
            <div className="salesrep-info">
                <div className="pe-row">
                    <div className="pe-col-4">
                        <label className="pe-label--bold">Sales Rep.Info</label>
                    </div>
                </div>
                <div className="pe-row">
                    <div className="pe-col-3">
                        <label className="pe-label--bold">Name</label>
                    </div>
                    <div className="pe-col-4 rep-info">
                        <label className="pe-label">{options.salesRepName}</label>
                    </div>
                </div>
                <div className="pe-row">
                    <div className="pe-col-3">
                        <label className="pe-label--bold">Email Address</label>
                    </div>
                    <div className="pe-col-4 rep-info">
                        <a href={"mailto:" + options.salesRepEmail}> {options.salesRepEmail}</a>
                    </div>
                </div>
                <div className="pe-row">
                    <div className="pe-col-3">
                        <label className="pe-label--bold">Territory</label>
                    </div>
                    <div className="pe-col-4 rep-info">
                        <label className="pe-label">{options.salesRepTerr}</label>
                    </div>
                </div>
                <div className="pe-row">
                    <div className="pe-col-3">
                        <label className="pe-label--bold">Area</label>
                    </div>
                    <div className="pe-col-4 rep-info">
                        <label className="pe-label">{options.salesRepArea}</label>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsComponents/SalesRep.js